module.exports = __webpack_public_path__ + "static/media/traffic_jams.3b45779c.jpg";